/**
 * First Light discrimination (spec: 2026-08-16-first-light-design.md, D4/D5).
 *
 * The phone's synthetic pairing-welcome notification arrives with this sentinel
 * pseudo-package. It is NOT the app's real package id ("dev.reflecto.app") —
 * Test Mirror relays under the real id via TEST_MIRROR_CHANNEL_ID, and a
 * sentinel no installed package produces keeps the two wire-indistinguishable
 * flows apart by construction. Shared here so extension and web cannot drift.
 */
export const FIRST_LIGHT_APP_PACKAGE = "dev.reflecto.firstlight";

export function isFirstLightPackage(appPackage: string): boolean {
  return appPackage === FIRST_LIGHT_APP_PACKAGE;
}

/**
 * Partition a freshly-seen notification batch: First Light payloads count as
 * `first_light_received` (delivery proof), never `first_notification_seen` or
 * the seen-count rollup — the organic-mirroring metrics stay synthetic-free.
 */
export function splitSeenBatch<T extends { appPackage: string }>(
  items: T[]
): { firstLight: T[]; organic: T[] } {
  const firstLight: T[] = [];
  const organic: T[] = [];
  for (const item of items) {
    (isFirstLightPackage(item.appPackage) ? firstLight : organic).push(item);
  }
  return { firstLight, organic };
}
